<template>
    <form
        class="mb-5"
        @submit.prevent="search"
    >
        <nav class="level is-block-tablet-only is-block-desktop-only">
            <div class="level-left is-block-tablet-only is-block-desktop-only">
            </div>

            <div class="level-right is-block-tablet-only is-block-desktop-only">
                <div class="level-item is-block-mobile is-block-tablet-only is-block-desktop-only">
                    <div class="field">
                        <label class="label is-size-7 has-text-weight-medium">
                            From date
                        </label>
                        <b-datepicker
                            :value="fromDate"
                            placeholder="Search from..."
                            :min-date="minimumDate ? $dayjs(minimumDate).toDate() : null"
                            :max-date="toDate"
                            icon="calendar-alt"
                            locale="en-GB"
                            @input="$emit('update:fromDate', $event) && search()"
                        />
                    </div>
                </div>
                <div class="level-item is-block-mobile is-block-tablet-only is-block-desktop-only">
                    <div class="field">
                        <label class="label is-size-7 has-text-weight-medium">
                            To date
                        </label>
                        <b-datepicker
                            :value="toDate"
                            placeholder="Search to..."
                            :min-date="fromDate"
                            :max-date="$dayjs().toDate()"
                            icon="calendar-alt"
                            locale="en-GB"
                            @input="$emit('update:toDate', $event) && search()"
                        />
                    </div>
                </div>
            </div>
        </nav>
    </form>
</template>

<script>
export default {
    props: {
        fromDate: {
            type: [String, Date],
            required: true,
        },
        toDate: {
            type: [String, Date],
            required: true,
        },
        minimumDate: {
            type: [String, Date],
            required: false,
            default: null,
        },
    },

    methods: {
        search() {
            this.$emit('search');
        },
    },
};
</script>
